var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#005EFF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9968 23.1748C15.6838 23.1748 11.9998 23.8548 11.9998 26.5748C11.9998 29.2958 15.6608 29.9998 19.9968 29.9998C24.3098 29.9998 27.9938 29.3208 27.9938 26.5998C27.9938 23.8788 24.3338 23.1748 19.9968 23.1748Z",
    fill: "#005EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.9967 20.584C22.9347 20.584 25.2887 18.229 25.2887 15.292C25.2887 12.355 22.9347 10 19.9967 10C17.0597 10 14.7047 12.355 14.7047 15.292C14.7047 18.229 17.0597 20.584 19.9967 20.584Z",
    fill: "#005EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.2057ca529ebcbddcd459a4da00fa736d.svg";
export { ForwardRef as ReactComponent };